import type { State } from "@App/state";

export const selectFleetVehicleReturn = (state: State) => {
  const vr = state.fleet.vehicleReturn;
  if (!vr) return null;
  return {
    agreementNumber: vr.agreementNumber,
    endDate: new Date(vr.endDate),
    authorizedReturnLocationIds: vr.authorizedReturnLocationIds,
  };
};
